var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTargetLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11h5V2H2v5H0V0h13v13H6v-2z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    stroke: "#F6F4F4",
    d: "M2.5 2.5h8v8h-8z"
  })));
}

var MemoSvgTargetLight = /*#__PURE__*/React.memo(SvgTargetLight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMTFIMTFWMkgyVjdIMFYwSDEzVjEzSDZWMTFaIiBmaWxsPSIjMTQxNDE0Ii8+CjxyZWN0IHg9IjIuNSIgeT0iMi41IiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjMTQxNDE0IiBzdHJva2U9IiNGNkY0RjQiLz4KPC9zdmc+CgoK";
export { MemoSvgTargetLight as ReactComponent };